import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "../../../theme/customTheme";

export const useStyles = makeStyles({
  modalImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    display: "block",
    margin: "0 auto",
  },
  mainWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  citationsLoading: {
    padding: designTokens.spacing[2],
    textAlign: "center",
    fontStyle: "italic",
    color: designTokens.neutral[400],
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "75%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  mainContainerMobile: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexWrap: "wrap",
    width: "100%",
    paddingBottom: designTokens.spacing[2],
    paddingLeft: designTokens.spacing[3],
  },
  buttonsContainerMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: designTokens.spacing[2],
    flexWrap: "wrap",
    width: "100%",
    paddingBottom: designTokens.spacing[2],
  },
  temporaryChatButton: {
    minWidth: "auto",
    ...shorthands.padding(designTokens.spacing[1]),
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[600],
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.accent[500],
    },
  },
  temporaryChatButtonActive: {
    backgroundColor: designTokens.accent[500],
    color: designTokens.neutral.white,
    ":hover": {
      backgroundColor: designTokens.accent[500],
      color: designTokens.neutral.white,
    },
    ":active": {
      backgroundColor: designTokens.accent[500],
      color: designTokens.neutral.white,
    },
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    marginBottom: designTokens.spacing[2],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: designTokens.neutral.white,
    gap: designTokens.spacing[1],
    width: "100%",
    maxWidth: "100%",
    border: `2px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius["2xl"],
    boxShadow: designTokens.shadow.md,
    overflow: "hidden",
    boxSizing: "border-box",
    paddingLeft: designTokens.spacing[2],
    ":focus-within": {
      border: `2px solid ${designTokens.accent[500]}`,
    },
  },
  helperText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
    textAlign: "right",
    paddingTop: designTokens.spacing[1],
    paddingRight: designTokens.spacing[2],
  },
  fieldContainerMobile: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    paddingTop: designTokens.spacing[1],
    paddingBottom: designTokens.spacing[1],
    paddingLeft: "0",
    paddingRight: "0",
    width: "100vw",
    maxWidth: "100%",
    boxSizing: "border-box",
    margin: "0",
  },
  inputContainerMobile: {
    display: "flex",
    alignItems: "center",
    backgroundColor: designTokens.neutral.white,
    gap: designTokens.spacing[1],
    width: "100%",
    maxWidth: "100%",
    border: `2px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius["2xl"],
    boxShadow: designTokens.shadow.md,
    overflow: "hidden",
    flexShrink: 1,
    boxSizing: "border-box",
    paddingLeft: designTokens.spacing[2],
    ":focus-within": {
      border: `2px solid ${designTokens.accent[500]}`,
    },
  },
});
